import { render, staticRenderFns } from "./OnboardingAppointInit.vue?vue&type=template&id=a2496626&"
import script from "./OnboardingAppointInit.vue?vue&type=script&lang=js&"
export * from "./OnboardingAppointInit.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingAppointInit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports